"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isPhoneNumber(value) {
  if (value == null) return false;
  return /^(\+\d{1,2})?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
}

exports.isPhoneNumber = isPhoneNumber;

function isEmpty(value) {
  if (value == null) return true;
  return value.trim().length == 0;
}

exports.isEmpty = isEmpty;

function isNotEmpty(value) {
  if (value == null) return false;
  return value.trim().length != 0;
}

exports.isNotEmpty = isNotEmpty; // copy from https://emailregex.com/

var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function isEmail(email) {
  return emailReg.test(email);
}

exports.isEmail = isEmail;

function getFileExtension(path) {
  if (path == null) return null;
  var lastIndex = path.lastIndexOf(".");

  if (lastIndex > -1) {
    return path.substr(lastIndex + 1);
  }

  return null;
}

exports.getFileExtension = getFileExtension;